function CollectionAddress() {
  return (
    <div className="center-items">
      <div
        style={{
          flex: 0.6,
          display: 'flex',
          alignItems: 'center',
          marginTop: '2vh',
        }}
      >
        <p className="header">Confirm your collection address</p>
      </div>
      <div style={{ flex: 1, width: '100%' }}>
        <p
          style={{
            border: '1px solid rgba(0, 0, 0, 0.12)',
            padding: '4% 3%',
            margin: '0 7% 4% 7%',
            lineHeight: '1.5em',
            color: '#00000099',
          }}
        >
          3c Bluestone Business Park,
          <br />
          Moyraverty West Road,
          <br />
          Moyraverty,
          <br />
          Craigavon,
          <br />
          Northern Island,
          <br />
          BT65 5HU
        </p>
      </div>
    </div>
  );
}

export default CollectionAddress;
